export const translations = {
	"en": {
		"Frames" : "Frames",
		"Todo": "All",
		"Semana": "Week",
		"Semanas": "Weeks",
		"Día": "Day",
		"% Avance": "Progress %",
		"% Faltante": "Remaining %",
		"Avance ": "Progress ",
		"Avance Temporal": "Temporal Progress",
		"Videos Subidos": "Uploaded Videos",
		"Cargando...": "Loading...",
        "Cargando": "Loading",
		"Mostrar indices": "Show Indexes",
        "Progreso": "Progress",
        "Áreas": "Areas",
        "Área": "Area",
        "Planos": "Plans",
        "Categorías": "Categories",
        "Categoría" : "Category",
        "Fecha": "Date",
		"Itemizado": "Items",
		"Seleccionar": "SELECT",
		"% para": "% real for ",
        "% planeado" : "% planned for ",
		"Mostrar Progreso": "Show Progress",
        "Mostrar Progreso Real": "Show Real Progress",
        "Recargar Página" : "Data load failed please reload page!",
        "Tarjeta inválida" : "The submit card ID is not valid!",
        "Tarjetas no encontradas" : "Cards not found!",
        "Recargar Proyecto" : "Reload Project",
        "Mostrar Progreso Planificado" : "Show Total Planned Progress",
        "Creador de la tarjeta" : "Creator of card",
        "Observación" : "Observation",
        "Observaciones": "Observations",
        "Usuarios a cargo" : "Users in charge",
        "Partida" : "Item",
        "Ninguna" : "None",
        "Ninguno" : "None",
        "Protocolo": "Protocol",
        "Protocolos" : "Protocols",
        "protocolo": "protocol",
        "protocolos": "protocols",
        "Formularios": "Forms",
        "Formulario General": "General Form",
        "Mostrar Estado de Protocolos" : "Show Protocol State",
        "Anexos": "Annexes",
        "Mostrar Gráfico de Presupuesto": "Show Price Graph",
        "Mostrar Presupuesto Planificado": "Show Total Planned Price",
        "Información": "Information",
        "Plano": "Plan",
        "Zona": "Zone",
        "Lámina": "Sheet",
        "Tramo" : "Stretch",
        "Mostrar Progreso de Firmas": "Show Signatures Progress",
        "Cargos": "Positions",
        "Tarjeta": "Card",
        "Tarjetas": "Cards",
        "Abiertos": "Open",
        "Abierto": "Open",
        "Pendiente": "Pendiente",
        "Pendientes": "Pending",
        "En Proceso": "In Process",
        "Cerrado": "Closed",
        "Cerrados": "Closed",
        "Etapas": "Stages",
        "Tarjetas en Partida": "Item Cards",
        "Mensaje de Advertencia": "An abnormal difference has been found between progress and quality protocols",
        "Diferencia": "Difference",
        "Click aquí": "Click here to see all observations",
        "Avance Real": "Real Progress",
        "Avance Calidad": "Quality Progress",
        "Ver Tarjetas": "See Cards",
        "En Espera": "In Queue",
        "Este registro aún no se envía": "This card has not been sent yet",
        "por enviar": "in stand by",
        "Enviar": "Send",
        "Revisiones": "Revisions",
        "Leyenda": "Legend",
        "Estados Protocolo": "Protocol States",
        "Revisar Protocolo(s)": "Review Protocol(s)",
        "Mostrar Linea de Tiempo": "Show Timeline",
        "Edificio 3D": "3D Building",
        "Ciclos": "Cycles",
        "Generar Ciclo": "Generate Cycle",
        "Con No Conformidades": "With No Conformities",
        "Firmar": "Sign",
        "No Liberado": "Not Released",
        "A Revisar": "To Check",
        "Con Observaciones": "With Observations",
        "Añadir Costos": "Add Costs",
        "Ha ocurrido un error al ingresar costos": "An error has occurred while entering costs",
        "Debe ingresar una fórmula válida": "You must enter a valid formula",
        "Asignarás costos a todos los registros visibles en pantalla. Al asignar costos permites cuantificar el avance en base al costo":
            "You will assign costs to all records visible on the screen. Assigning costs allows you to quantify progress on a cost basis",
        "Registros visibles": "Visible records",
        "Registros seleccionados": "Selected records",
        "Unidad de medida": "Unit of measure",
        "Tipo de Asignación": "Type of Assignment",
        "Costo Total": "Total Cost",
        "Costo Unitario": "Unit Cost",
        "Costo": "Cost",
        "Fórmula": "Formula",
        "Ponderador": "Weighting",
        "Cantidad Total": "Total Quantity",
        "Que la cantidad sea el resultado de la fórmula":"The quantity is the result of the formula",
        "Se han agregado costos a": "Costs have been added to",
        "registros exitosamente" : "records successfully",
        "Mostrar Ejes": "Show Axes",
        "Mostrar Calles": "Show Streets",
        "Ver Métricas": "See Metrics",
        "Opacidad": "Opacity",
        "Configuración": "Configuration",
        "Filtros": "Filters",
        "Filtro de Tiempo": "Time Filter",
        "Firmas": "Signatures",
        "Agregar Filtro": "Add Filter",
        "Usuario": "User",
        "Color en Base a": "Color based on",
        "Estado de Protocolo": "Protocol Status",
        "Protocolo Atrasado": "Delayed Protocol",
        "Progreso Real": "Real Progress",
        "Elemento": "Element",
        "Registros filtrados para descargar": "Filtered records for download",
        "Estamos preparando los certificados. Te enviaremos un link a tu correo cuando la descarga esté lista": 
            "We are preparing the certificates. We will send you a link to your email when the download is ready.",
        "Se han exportado Observaciones correctamente": "Observations have been exported correctly",
        "Se han exportado Registros correctamente" : "Records have been exported correctly",
        "Ha ocurrido un error al exportar": "An error occurred while exporting",
        "Observaciones": "Observations",
        "Registros": "Records",
        "registros": "records",
        "registro": "record",
        "Exportar": "Export",
        "La extensión de este archivo es": "The extension of this file is",
        "A partir de": "From",
        "disponibles": "available",
        "disponible": "available",
        "certificados": "certificates",
        "Certificados": "Certificates",
        "Agrupar Registros por": "Group Records by",
        "No agrupar": "Not group",
        "Exportar todo en un solo PDF": "Export all in a single PDF",
        "Recargar": "Reload",
        "No Atrasado": "Not Delayed",
        "Atrasado": "Delayed",
        "Día": "Day",
        "Días": "Days",
        "a": "to",
        "No": "Not",
        "Pagado": "Paid",
        "y": "and",
        "Entregado": "Delivered",
        "Iniciado": "Initiated",
        "Menos del": "Less than",
        "Entre el": "Between",
        "Sobre": "Over",
        "Bajo": "Under",
        "Por Entregar": "To be delivered",
        "Ver más": "See more",
        "Liberar": "Release",
        "Agregar Avance": "Add Advance",
        "Agrupar": "Group",
        "Se han agrupado los protocolos correctamente": "The protocols have been correctly grouped",
        "No se pudieron agrupar los protocolos": "Protocols could not be grouped",
        "Agrupar Elementos": "Group Elements",
        "Agrupando Protocolos": "Grouping Protocols",
        "Revisar": "Review",
        "Cerrar Protocolos": "Close Protocols",
        "Opciones": "Options",
        "Modo Edición":"Edit Mode",
        "Departamentos": "Departments",
        "Departamento": "Department",
        "Agregando Pago": "Adding Payment",
        "Agregando Avance": "Adding Advance",
        "Porcentaje de pago agregado exitosamente": "Percentage of payment successfully added",
        "Ocurrió un error, no se pudo agregar el porcentaje de pago": "An error occurred, the payment percentage could not be added",
        "Agregar Pago": "Add Payment",
        "Seleccione filtrar registros por": "Seleccione filtrar registros por",
        "Elemento BIM": "BIM element",
        "Volumen": "Volume",
        "Superficie": "Surface",
        "Altura": "Height",
        "Avance agregado exitosamente": "Progress successfully added",
        "Ocurrió un error, no se pudo agregar el avance": "An error occurred, the advance could not be added",
        "Cambiando Categoría": "Changing Category",
        "Categoría cambiada exitosamente": "Category successfully changed",
        "Ocurrió un error, no se pudo cambiar la categoría": "An error occurred, the category could not be changed",
        "Cambiar Categoría": "Change Category",
        "Cambiar": "Change",
        "Cambiando Piso": "Changing Level",
        "Piso cambiado exitosamente": "Level successfully changed",
        "Ocurrió un error, no se pudo cambiar el Piso": "An error occurred, the Level could not be changed",
        "Cambiar Piso": "Change Level",
        "Revisión": "Review",
        "Datos Generales": "General Data",
        "Conforme": "Conform",
        "Sin": "Without",
        "Agregar el 100% de avance": "Add 100% progress",
        "Quitar último porcentaje de avance": "Remove last percentage of progress",
        "Agregar Nuevo Protocolo": "Add New Protocol",
        "No tienes permisos para agregar porcentajes pagados": "You do not have permission to add paid percentages",
        "Marcar como Pagado": "Mark as Paid",
        "No tienes permisos para agregar avances": "You do not have permissions to add progress",
        "Encargados": "Users in charge",
        "No tienes permisos para eliminar protocolos": "You do not have permission to delete protocols",
        "Seguro que no deseas devolver estos protocolos a pendiente": "Are you sure you don't want to return these protocols to pending",
        "Estas seguro de eliminar": "Are you sure to delete",
        "Eliminar": "Delete",
        "Estirar Túnel": "Stretch Tunnel",
        "Cantidades": "Quantities",
        "protocolos seleccionados": "selected protocols",
        "protocolo seleccionado": "selected protocol",
        "Se han generado los protocolos correctamente": "Protocols have been generated correctly",
        "No se pudieron generar los protocolos": "Protocols could not be generated",
        "Busca Aquí": "Search here",
        "Generar": "Generate",
        "Seguro que deseas reabrir estos protocolos": "Are you sure you want to reopen these protocols",
        "Reabrir": "Reopen",
        "Estás seguro de dejar en pendiente": "Are you sure to leave in pending",
        "Devolver a Pendiente(s)": "Return to Pending(s)",
        "Se ha generado el ciclo correctamente": "Cycle has been generated correctly",
        "No se pudo generar el ciclo": "The cycle could not be generated",
        "Ir a Ciclos": "Go to Cycles",
        "Se han desagrupado los protocolos correctamente": "Protocols have been correctly ungrouped",
        "No se pudieron desagrupar los protocolos": "Protocols could not be ungrouped",
        "Desagrupar": "Ungroup",
        "Editando avance": "Editing progress",
        "Avance editado exitosamente": "Advance successfully edited",
        "Ocurrió un error al editar el avance": "An error occurred while editing the preview",
        "Cancelar": "Cancel",
        "Confirmar": "Confirm",
        "Eliminando protocolos": "Deleting protocols",
        "Protocolos eliminados exitosamente": "Protocols successfully deleted",
        "Protocolo eliminado exitosamente": "Protocol successfully deleted",
        "Ocurrió un error al eliminar los protocolos": "An error occurred while deleting the protocols",
        "Devolver": "Return",
        "No tiene un protocolo asociado": "No associated protocol",
        "No tiene un equipo asociado": "No associated equipment",
        "No se ha completado un protocolo anterior": "A previous protocol has not been completed",
        "Reabriendo protocolos": "Reopening protocols",
        "Protocolos Reabiertos exitosamente": "Protocols successfully reopened",
        "Protocolo Reabierto exitosamente": "Protocol successfully reopened",
        "Ocurrió un error al reabrir los protocolos": "An error occurred when reopening protocols",
        "Filtrando": "Filtering",
        "Filtro Aplicado": "Filter Applied",
        "Ocurrió un error al filtrar": "An error occurred while filtering",
        "Firmados": "Signed",
        "Sin Firmar": "Unsigned",
        "Editando protocolos": "Editing protocols",
        "Protocolos editados exitosamente": "Successfully edited protocols",
        "Protocolo editado exitosamente": "Successfully edited protocol",
        "Ocurrió un error al editar los protocolos": "An error occurred while editing the protocols",
        "Métrica No Disponible": "Metric Not Available",
        "Protocolos por Estado": "Protocols by State",
        "Porcentaje de Cumplimiento": "Percentage of Compliance",
        "Resumen de Protocolos por Usuario": "Summary of Protocols per User",
        "Atrasos por Estado": "Arrears per State",
        "Atrasos por Usuario": "Arrears per User",
        "Atrasos por Etapa": "Arrears per Stage",
        "Atrasos por Piso": "Arrears per Level",
        "Atrasos por Protocolo": "Arrears per Protocol",
        "% de Cumplimiento por Persona": "% of Compliance per Person",
        "% de Observaciones": "% of Observations",
        "Observaciones por Etapa": "Observations per Stage",
        "Observaciones por Criterio": "Observations per Criterion",
        "Observaciones Históricas por Protocolo": "Historical Observations per Protocol",
        "Curva S": "S Curve",
        "Estado de Pago": "Payment Status",
        "Métricas disponibles": "Available metrics",
        "Se han liberado los protocolos correctamente": "Protocols have been released correctly",
        "Los siguientes protocolos no se pudieron liberar": "The following protocols could not be released",
        "Sin Turno": "No Shift",
        "En": "In",
        "días el registro se considerará atrasado, si aún no ha sido cerrado": "days the record will be considered overdue, if it has not yet been closed",
        "Elegir Turno Encargado": "Choose Manager Shift",
        "Protocolos cerrados exitosamente": "Protocols successfully closed",
        "Protocolos firmados exitosamente": "Protocols successfully signed",
        "Ocurrió un error al cerrar los protocolos": "An error occurred when closing the protocols",
        "Ocurrió un error al firmar los protocolos": "An error occurred while signing the protocols",
        "Enviando": "Sending",
        "Enviar Firma": "Send Signature",
        "Continuar": "Continue",
        "Si hay protocolos por revisar o con observaciones": "If there are protocols to be reviewed or with observations",
        "se le agregará una nueva revisión igualmente": "a new revision will also be added",
        "Agregar nueva revisión": "Add new revision",
        "Avance Planificado": "Planned Progress",
        "Ver Tutorial": "Watch Tutorial",
        "Ver Últimos Cambios": "View Latest Changes",
        "Piso": "Level",
        "Ingresar Firma": "Enter Signature",
        "Atención, faltan las siguientes firmas de usuarios en los protocolos seleccionados": "Attention, the following user signatures are missing in the selected protocols",
        "Ingresar Fecha de Término": "Enter Term Date",
        "Fecha de Término": "Term Date",
        "Liberando": "Releasing",
        "ID tarjeta": "Card ID",
        "Desagrupando Protocolos": "Ungrouping Protocols",
        "No hay ciclos disponibles, agregue ciclos antes de continuar": "No cycles available, add cycles before continuing",
        "Seleccione un Ciclo": "Select a Cycle",
        "Generando Ciclo": "Generating Cycle",
        "Seleccione los Protocolos que desea agregar": "Select the Protocols you want to add",
        "Generando Nuevos Protocolos": "Generating New Protocols",
        "Inicio": "Start",
        "Fecha de Inicio": "Start Date",
        "Final": "End",
        "Ingrese un porcentaje de Avance": "Enter a percentage of progress",
        "Ingrese un porcentaje de Pago": "Enter a Payment Percentage",
        "Puedes liberar este Registro para que sea revisado": "You can release this Record for review",
        "Asignar/Desasignar Encargados": "Assign/Unassign Users in charge",
        "Asignarás o desasignarás encargados a los registros seleccionados": "Assign or unassign users in charge to selected records",
        "Seleccionar Usuarios": "Select Users",
        "Asignar Encargados": "Assign Users",
        "Desasignar Encargados": "Unassign Users",
        "Desea asignar los usuarios seleccionados a": "Do you want to assign the selected users to",
        "Desea desasignar los usuarios seleccionados a": "Do you want to unassign the selected users to",
        "Ha ocurrido un error al asignar/desasignar encargados": "An error occurred while assigning/unassigning users in charge",
        "Pendiente": "Pending"
	},
	"es": {
		"Frames" : "Frames",
		"Todo": "Todo",
		"Semana ": "Semana ",
		"Semanas": "Semanas",
		"Dia ": "Día ",
		"% Avance": "% Avance",
		"% Faltante": "% Faltante",
		"Avance ": "Avance ",
		"Avance Temporal": "Avance Temporal",
		"Videos Subidos": "Videos Subidos",
		"Cargando...": "Cargando...",
        "Cargando": "Cargando",
		"Mostrar indices": "Mostrar Índices",
        "Progreso": "Progreso",
        "Áreas": "Áreas",
        "Planos": "Planos",
        "Categorías": "Categorías",
        "Categoría" : "Categoría",
        "Fecha ": "Fecha ",
		"Itemizado": "Itemizado",
		"Seleccionar": "SELECCIONAR",
		"% para": "% real para ",
        "% planeado" : "% planificado para ",
		"Mostrar Progreso": "Mostrar Progreso",
        "Mostrar Progreso Real": "Mostrar Progreso Real",
        "Recargar Página" : "Error al cargar datos por favor recargar la página!",
        "Tarjeta inválida" : "El ID de la tarjeta ingresada es inválido!",
        "Tarjetas no encontradas" : "Tarjetas no encontradas!",
        "Recargar Proyecto" : "Recargar Proyecto",
        "Mostrar Progreso Planificado" : "Mostrar Progreso Planificado Total",
        "Creador de la tarjeta" : "Creador de la tarjeta",
        "Observación" : "Observación",
        "Observaciones": "Observaciones",
        "Usuarios a cargo" : "Usuarios a cargo",
        "Partida" : "Partida",
        "Ninguna" : "Ninguna",
        "Ninguno" : "Ninguno",
        "Protocolo": "Protocolo",
        "Protocolos": "Protocolos",
        "Formularios": "Formularios",
        "Formulario General": "Formulario General",
        "Mostrar Estado de Protocolos": "Mostrar Estado de Protocolos",
        "Anexos": "Anexos",
        "Mostrar Gráfico de Presupuesto": "Mostrar Gráfico de Presupuesto",
        "Mostrar Presupuesto Planificado": "Mostrar Presupuesto Planificado Total",
        "Información": "Información",
        "Plano": "Plano de Referencia",
        "Zona": "Zona",
        "Lámina": "Lámina",
        "Tramo" : "Tramo",
        "Mostrar Progreso de Firmas": "Mostrar Progreso de Firmas",
        "Cargos": "Cargos",
        "Tarjeta": "Tarjeta",
        "Tarjetas": "Tarjetas",
        "Abierto": "Abierto",
        "Abiertos": "Abiertos",
        "Pendiente": "Pendiente",
        "Pendientes": "Pendientes",
        "En Proceso": "En Proceso",
        "Cerrado": "Cerrado",
        "Cerrados": "Cerrados",
        "Etapas": "Etapas",
        "Tarjetas en Partida": "Tarjetas en Partida",
        "Mensaje de Advertencia": "Existe una gran diferencia entre el avance real y el avance de calidad.",
        "Diferencia": "Diferencia",
        "Click aquí": "Click aquí para ver todas las observaciones",
        "Avance Real": "Avance Real",
        "Avance Calidad": "Avance Calidad",
        "Ver Tarjetas": "Ver Tarjetas",
        "En Espera": "En Espera",
        "Este registro aún no se envía": "Este registro aún no se envía",
        "por enviar": "por enviar",
        "Enviar": "Enviar",
        "Revisiones": "Revisiones",
        "Leyenda": "Leyenda",
        "Estados Protocolo": "Estados Protocolo",
        "Revisar Protocolo(s)": "Revisar Protocolo(s)",
        "Mostrar Linea de Tiempo": "Mostrar Linea de Tiempo",
        "Edificio 3D": "Edificio 3D",
        "Ciclos": "Ciclos",
        "Generar Ciclo": "Generar Ciclo",
        "Con No Conformidades": "Con No Conformidades",
        "Firmar": "Firmar",
        "No Liberado": "No Liberado",
        "A Revisar": "A Revisar",
        "Con Observaciones": "Con Observaciones",
	}
}